export default __webpack_public_path__ + "static/media/HH59789.1eb12a72.jpg";